import { FormCustomFieldRendererParams } from '@/components/Form';
import type { WorkspaceSubjectType } from '@/modules/corporate/modules/workspaceSettings/components/AddWorkspacesSettings';

import WorkspaceSettings from '../components/WorkspaceSettings';

export const renderWorkspaceSettings =
  (contentName: string, type?: WorkspaceSubjectType, disabled?: boolean) =>
  (formikData: FormCustomFieldRendererParams<string[] | null | undefined>) => {
    const { value, onChange } = formikData;

    return (
      <WorkspaceSettings
        contentName={contentName}
        disabled={Boolean(disabled)}
        selectedValues={value ?? undefined}
        type={type}
        onChange={onChange}
      />
    );
  };
